import { HOME } from "../constants/testIds";
import Reveal from "../components/loadout/Reveal";
import { BUSINESS } from "../constants/business";

// [11] Final trust band — 96px min, canvas bg, 1px divider top border.
export default function FinalTrustBand() {
  return (
    <section
      data-testid={HOME.finalTrustBand}
      className="bg-[#0A0A0A] text-white border-t border-[#1F1F1F]"
      style={{ minHeight: 96 }}
    >
      <div className="mx-auto max-w-[1440px] px-6 py-6 text-center">
        <Reveal>
          <div className="font-display text-white text-[20px] md:text-[22px] leading-[1.1]">
            Authenticity Guaranteed. Verified Indian Stock.
          </div>
        </Reveal>
        <Reveal delay={60}>
          <div className="mt-2 font-sans text-[13px] md:text-[14px] text-[#8A8A8A]">
            Operated by {BUSINESS.entity}.
          </div>
        </Reveal>
      </div>
    </section>
  );
}
